import {
	/* DEFAULT_MEDIA_QUERY_PLATFORMS, */
	COMPONENT_TYPE as TYPE,
	LAYER_TYPE,
	COMPONENT_DISPLAY_NAME,
} from 'common/constants';
import { generateElementId, generateNodeId } from 'utils/generate-id';
import View from 'client/components/common/BuildingBlocks/FloatAbove/FloatAbove';

export const FLOAT_ABOVE = () => {
	const _id = generateElementId();

	return {
		view: View,
		get model() {
			const type = TYPE.FLOAT_ABOVE;

			return {
				_id,
				type,
				uiConfig: {
					layer: LAYER_TYPE.CONTENT,
					editorProps: {
						name: COMPONENT_DISPLAY_NAME[type],
						selectable: false,
						draggable: false,
						expandable: true,
						expanded: true,
					},
					nodeProps: {
						id: generateNodeId(_id, 'fla'),
					},
					componentProps: {
						styles: {},
						other: {},
					},
				},
				children: [],
			};
		},
	};
};
